import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment, { Moment } from 'moment';

export function createDatetimeRangeValidator(minDate?: Date, maxDate?: Date): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    const start: Moment = control?.value?.start ? moment(control?.value?.start) : null;

    const end: Moment = control?.value?.end ? moment(control?.value?.end) : null;

    if (start && end) {
      const isRangeValid = start.isBefore(end);

      if (isRangeValid) {
        const isStartValid = minDate && maxDate ? start.isBetween(minDate, maxDate, 'day', '[]') : true;
        const isEndValid = minDate && maxDate ? end.isBetween(minDate, maxDate, 'day', '[]') : true;

        return isStartValid && isEndValid ? null : { between: true };
      }

      return isRangeValid ? null : { datetimeRange: true };
    }

    return null;
  };
}

export function dateBetweenValidator(minDate: Date, maxDate: Date): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    const value: string | Date = control?.value;

    if (value && minDate && maxDate) {
      const valid = moment(value).isValid() && moment(value).isBetween(minDate, maxDate, 'day', '[]');

      return valid ? null : { between: true };
    }

    return null;
  };
}
